"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditorImageBorderIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M17 9h1v3h-1zm0 4h1v2h-1zM6 9h1v2H6zm0 3h1v3H6zm3 5h2v1H9zm3 0h3v1h-3zM9 6h3v1H9zm4 0h2v1h-2zm-7 .505C6 6.226 6.214 6 6.505 6H8v1H7v1H6zm12 0V8h-1V7h-1V6h1.495c.291 0 .505.226.505.505M6 17.495V16h1v1h1v1H6.505A.497.497 0 0 1 6 17.495m12 0a.497.497 0 0 1-.505.505H16v-1h1v-1h1z"/></svg>`
}, props));
EditorImageBorderIcon.displayName = 'EditorImageBorderIcon';
var _default = exports.default = EditorImageBorderIcon;